import html2canvas from 'html2canvas'
import JSPDF from 'jspdf'

function getVerticalDistance(element, ancestor) {
  let distance = 0
  while (element !== ancestor && element !== null) {
    distance += element.offsetTop
    element = element.offsetParent
  }
  return distance
}

const html2pdf = (type, elementId, pdfName, callback) => {
  const element = document.getElementById(elementId)
  if (element) {
    const marginX = 10 // pdf 每页的边距
    const marginY = 30 // pdf 每页的边距
    const a4w = 592.28 - 2 * marginX
    const a4h = 841.89 - 2 * marginY // pdf 内容的宽高

    html2canvas(element, {
      useCORS: true, // 允许加载跨域图片
      onclone: (clone) => {
        if (elementId) {
          const cloneDOM = clone.getElementById(elementId)
          cloneDOM.style.width = '1180px'
          const pList = cloneDOM.getElementsByTagName('p')
          const pageHeight = Math.floor((a4h * cloneDOM.offsetWidth) / a4w)
          for (let i = 0; i < pList.length; i += 1) {
            if (['', '\n'].includes(pList[i].innerText)) {
              pList[i].remove()
            } else {
              const itemTop = getVerticalDistance(pList[i], cloneDOM)
              const multiple = Math.ceil(itemTop / pageHeight)
              const nextItem = pList[i + 1]
              if (itemTop < pageHeight * multiple && nextItem && getVerticalDistance(nextItem, cloneDOM) > pageHeight * multiple) {
                pList[i].style.marginTop = '30px' // 添加 marginTop 防止内容被截断
              }
            }
          }
        }
      },
    }).then((canvas) => {
      const pdf = new JSPDF('p', 'pt', [592.28, 841.89])
      const ctx = canvas.getContext('2d')
      const imgHeight = Math.floor((a4h * canvas.width) / a4w)
      let renderedHeight = 0

      while (renderedHeight < canvas.height) {
        const page = document.createElement('canvas')
        page.width = canvas.width
        page.height = Math.min(imgHeight, canvas.height - renderedHeight)
        page
          .getContext('2d')
          .putImageData(
            ctx.getImageData(
              0,
              renderedHeight,
              canvas.width,
              Math.min(imgHeight, canvas.height - renderedHeight)
            ),
            0,
            0
          )
        pdf.addImage(
          page.toDataURL('image/jpeg', 1.0),
          'JPEG',
          marginX,
          marginY,
          a4w,
          Math.min(a4h, (a4w * page.height) / page.width)
        )
        renderedHeight += imgHeight
        if (renderedHeight < canvas.height) {
          pdf.addPage()
        }
        page.remove()
      }
      if (type === 'print') {
        pdf.autoPrint()
        window.open(pdf.output('bloburl'), '_blank')
      } else {
        pdf.save(pdfName)
      }
      if (callback) {
        callback()
      }
    })
  }
}

export default html2pdf
